class Messages {
  static messages = {
    4001: {
      es: "Todos los cupos para este evento están llenos.",
      en: "All slots are filled for this event",
    },
    4002: {
      es: "No hay más equipos disponibles para este evento.",
      en: "There are no more available equipments for this event",
    },
    4003: {
      es: "Ya tienes una sesión programada para este evento.",
      en: "You already have a session scheduled for this event",
    },
    4004: {
      es: "Estás penalizada para este evento, elige otro tipo.",
      en: "You are penalized for this event, choose another type",
    },
    4005: {
      es: "No tienes una membresía activa, ve a planes para elegir una.",
      en: "You don't have an active membership, go to plans to choose one",
    },
    4006: {
      es: "La hora del evento está restringida para tu plan actual.",
      en: "The event time is restricted for your current plan",
    },
    4007: {
      es: "Ya has tomado una clase",
      en: "You have already taken a class",
    },
    4008: {
      es: "El plan está congelado, puedes activarlo en tu perfil.",
      en: "The plan is frozen, you can activate it in your profile",
    },
    SUCCESS_SCHEDULE: {
      es: "Sesión agendada exitosamente. Disfruta tu clase.",
      en: "Session scheduled successfully. Enjoy your class.",
    },
    UNKNOWN_ERROR: {
      es: "Error desconocido, contacte al soporte.",
      en: "Unknown error, please contact support.",
    },
  };

  static getMessage(errorCode, language) {
    const isSpanish = language.startsWith("es");
    const errorMessage = this.messages[errorCode] || this.messages["UNKNOWN_ERROR"];
    return isSpanish ? errorMessage.es : errorMessage.en;
  }
}

export default Messages;